<template>
  <label :for="id" class="flex items-center cursor-pointer select-none">
    <input
      :id="id"
      type="radio"
      :name="name"
      :value="value"
      :checked="isChecked"
      @change="handleChange"
      class="hidden"
    />
    <div
      class="w-[18px] h-[18px] rounded-full border-2 transition-all duration-200 ease-in-out flex items-center justify-center"
      :class="{
        'border-primary': isChecked,
        'border-gray-400': !isChecked
      }"
    >
      <div
        class="w-2.5 h-2.5 rounded-full bg-primary transition-all duration-200 ease-in-out"
        :class="{
          'opacity-100 scale-100': isChecked,
          'opacity-0 scale-0': !isChecked
        }"
      ></div>
    </div>
    <span class="ml-2 text-textPrimary text-base">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  id: string
  name: string
  value: string | number | boolean
  modelValue: string | number | boolean
  label?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number | boolean): void
}>()

const isChecked = computed(() => props.modelValue === props.value)

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}
</script>

<style scoped></style>
